import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  Grid: {
    padding: "0.5rem",
    display: "block",
    [theme.breakpoints.up("sm")]: {
      padding: "2rem",
      display: "flex",
    },
  },
  Input: {
    marginBottom: 15,
    width: "100%",
    "& .MuiInputBase-root": {
      width: "100%",
    },
  },
  Button: {
    display: "flex",
    width: "100%",
    marginTop: 10,
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      minWidth: "120px",
    },
  },
  ButtonVoltar: {
    marginBottom: 15,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
    },
  },
  parcelalabel: {
    fontWeight: "bold !important",
    fontSize: "17px !important",
    paddingLeft: "10px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "15px !important",
    },
  },
  total: {
    opacity: 0.7,
    fontSize: "15px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px !important",
    },
  },
  parcela: {
    paddingLeft: 10,
  },
  formCheck: {
    display: "flex",
    alignItems: "center !important",
    "& .form-check-label": {
      margin: "0 !important",
      marginLeft: ".5rem !important",
      marginTop: ".2rem !important",
    },
  },
  // Novos estilos responsivos
  mobilePadding: {
    padding: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(2),
    },
  },
  responsiveText: {
    fontSize: "14px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
  },
  stackButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      gap: "15px",
    },
  },
}));

export default useStyles;
